module.exports = __webpack_public_path__ + "videos/highlights.1e96b4d.mp4";